/**
 * Runtime ONNX compartido por los escáneres (patentes, odómetro).
 *
 * WebGPU cuando el navegador lo expone (iOS 18+, Chrome/Edge de escritorio):
 * corre los modelos en la GPU, varias veces más rápido que wasm de un hilo →
 * más cuadros por segundo → más votos por carácter en menos tiempo.
 * wasm (1 hilo) siempre queda de respaldo: no requiere cross-origin isolation.
 */

let ortPromise: Promise<any> | null = null;

export async function cargarOrt(): Promise<any> {
  if (!ortPromise) {
    ortPromise = import('onnxruntime-web')
      .then((ort) => {
        ort.env.wasm.wasmPaths = '/models/ort/';
        ort.env.wasm.numThreads = 1;
        return ort;
      })
      .catch((e) => {
        ortPromise = null; // permitir reintento si falló la descarga
        throw e;
      });
  }
  return ortPromise;
}

export const hayWebGPU = () => typeof navigator !== 'undefined' && Boolean((navigator as any).gpu);

/** Qué backend terminó usando la última sesión creada (para diagnóstico) */
export let backendActivo: 'webgpu' | 'wasm' = 'wasm';

/**
 * Crea una sesión probando WebGPU primero y cayendo a wasm si el equipo no
 * puede (sin adaptador, driver viejo, modelo con ops no soportadas).
 */
export async function crearSesion(ort: any, url: string): Promise<any> {
  if (hayWebGPU()) {
    try {
      const s = await ort.InferenceSession.create(url, { executionProviders: ['webgpu', 'wasm'] });
      backendActivo = 'webgpu';
      return s;
    } catch (e) {
      console.warn('[ORT] WebGPU no disponible para', url, '- uso wasm:', (e as any)?.message || e);
    }
  }
  const s = await ort.InferenceSession.create(url, { executionProviders: ['wasm'] });
  backendActivo = 'wasm';
  return s;
}
